import { Stack, Typography } from "@mui/material";
import { generatePath, To } from "react-router";

import { GaiaSubtleLink } from "~/modules/app/components/GaiaSubtleLink";

import { AreaCardHeaderFragment } from "./fragments.generated";

type AreaCardHeaderProps = {
    area: AreaCardHeaderFragment;
    areaNameHref: (areaId: string) => To;
};

export function AreaCardHeader({ area, areaNameHref }: AreaCardHeaderProps) {
    return (
        <Stack paddingBlock={1} flexGrow={1}>
            <Typography variant="caption">
                <GaiaSubtleLink
                    to={generatePath("/c/:clientSlug/p/:projectSlug", {
                        clientSlug: area.project.client.slug,
                        projectSlug: area.project.slug,
                    })}
                >
                    {area.project.name}
                </GaiaSubtleLink>{" "}
                •{" "}
                <GaiaSubtleLink to={generatePath("/c/:clientSlug", { clientSlug: area.project.client.slug })}>
                    {area.project.client.name}
                </GaiaSubtleLink>
            </Typography>
            <Typography variant="h6">
                <GaiaSubtleLink to={areaNameHref(area.id)}>{area.name}</GaiaSubtleLink>
            </Typography>
        </Stack>
    );
}
